import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import useRouter from "hooks/useRouter";
import {
  deleteContact,
  clearContactAction
} from "actions/contacts/contactActions";

import history from "../../history";

const ContactDelete = ({ formId, closeModal, selected }) => {
  const routingParams = useRouter();
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearContactAction());
    };
  }, [dispatch]);

  const handleDelete = e => {
    e.preventDefault();
    dispatch(deleteContact(selected));
    if (
      routingParams.match.path === "/contacts/:id" ||
      routingParams.match.path === "/contacts/:id/edit"
    ) {
      history.push("/contacts");
    } else {
      closeModal();
    }
  };

  return (
    <form
      id={formId}
      onSubmit={e => handleDelete(e)}
      className="form container"
    >
      <div>
        Are you sure you want to delete this contact? This can not be undone.
      </div>
    </form>
  );
};

export default ContactDelete;
